/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from '@api-util/mbp';
import restClient from '../../app/helpers/restClient';

const PAYMENT_SERVICE_ENV = {
    protocol: 'https',
    host: mbpUtil.getEnv('PAYMENT_HOST') || 'payment.18f.tech',
    prefix: '/r/api',
    rootUri: '/payment-services/protect/v1',
};
const RESOURCE_PAGE = '/tokenize-card';

const getAnonymousId = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem('browserUUID') || '';
    }

    return '';
};

export const tokenizeCard = async ({ jwtToken, payload }) => {
    const anonymousId = getAnonymousId();
    const headers = {
        token: jwtToken,
    };

    if (anonymousId) {
        headers.anonymousId = anonymousId;
    }

    return restClient.postFacade(
        PAYMENT_SERVICE_ENV,
        RESOURCE_PAGE,
        jwtToken,
        payload,
        null,
        headers,
        false,
    ).then((response) => response);
};

export default tokenizeCard;
